export default __webpack_public_path__ + "static/media/dutchgot-screenshot-01.f721ff14.png";